import { FaFileInvoice, FaTimesCircle, FaBox, FaBolt, FaBrain } from 'react-icons/fa';

function CashFlowSection({ buyLink, onBuyClick }) {
  const features = [
    {
      icon: <FaFileInvoice className="text-3xl sm:text-4xl text-amber-400" />,
      title: "Advance Invoicing",
      subtitle: ""
    },
    {
      icon: <FaTimesCircle className="text-3xl sm:text-4xl text-amber-400" />,
      title: "Cheque Bounce Control System",
      subtitle: ""
    },
    {
      icon: <FaBox className="text-3xl sm:text-4xl text-amber-400" />,
      title: "Dead Stock Liquidation Strategy",
      subtitle: ""
    },
    {
      icon: <FaBolt className="text-3xl sm:text-4xl text-amber-400" />,
      title: "Convert slow paying into fast paying customers  ",
      subtitle: ""
    },
    {
      icon: <FaBrain className="text-3xl sm:text-4xl text-amber-400" />,
      title: "Train your Brain",
      subtitle: ""
    }
  ];

  return (
    <section className="relative py-24 px-4 sm:px-8 bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* CTA Button */}
        <div className="text-center mb-14">
          <button 
            onClick={onBuyClick}
            className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-slate-900 px-12 sm:px-20 py-4 sm:py-5 rounded-xl text-lg sm:text-2xl font-extrabold shadow-[0_10px_20px_-5px_rgba(251,191,36,0.4)] hover:shadow-[0_20px_30px_-8px_rgba(251,191,36,0.5)] hover:-translate-y-0.5 transition-all duration-200 tracking-wide cursor-pointer"
          >
            Book a call →
          </button>
        </div>

        {/* Title */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white text-center mb-12 drop-shadow-lg">
          Cash Flow Management
        </h2>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-5 max-w-[1400px] mx-auto">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-5 sm:p-6 text-center border border-amber-500/20 hover:border-amber-500/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.4),0_8px_10px_-6px_rgba(0,0,0,0.4)]"
            >
              {/* Icon */}
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-5 rounded-xl bg-amber-500/15 flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300">
                {feature.icon}
              </div>

              {/* Title */}
              <div className="text-base sm:text-lg text-white font-extrabold mb-2 leading-tight">
                {feature.title}
              </div>
              
              {/* Subtitle */}
              {feature.subtitle && (
                <div className="text-sm sm:text-base text-slate-400 font-medium">
                  {feature.subtitle}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CashFlowSection;
